import { Coins } from "lucide-react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

/**
 * PawnFieldsSection — Jun-2026 (User-Wunsch).
 *
 * Spezifische Felder für die Verkaufsart „Pfand / Refinanzieren" (sale_type=pawn):
 * Auszahlungsbetrag (€), Laufzeit (Monate) und Rückkaufpreis (€). Das Fahrzeug
 * selbst wird wie bei Auktion/Vermietung über die Bestandsauswahl gewählt
 * (AuctionVehicleSource). Verfügbar für Händler UND Privatkunden.
 *
 * Reines Präsentations-Element — Setter kommen via `update(k,v)` vom Parent.
 */
export default function PawnFieldsSection({ form, update }) {
    const usages = Array.isArray(form.pawn_usages) ? form.pawn_usages : [];
    const USAGE_OPTIONS = [
        { key: "payout", label: "Auszahlung" },
        { key: "buy_vehicles", label: "Zum Kauf von Fahrzeugen im System" },
        { key: "offset_open_items", label: "Zur Verrechnung offener Posten im System" },
    ];
    const toggleUsage = (key) => {
        const next = usages.includes(key) ? usages.filter((u) => u !== key) : [...usages, key];
        update("pawn_usages", next);
    };
    return (
        <div className="bg-[#111827] text-white rounded-sm p-6 grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="pawn-fields">
            <h2 className="md:col-span-3 font-display text-lg font-bold flex items-center gap-2">
                <Coins className="w-5 h-5 text-[#FFCC00]" /> Pfand / Refinanzieren
            </h2>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    Auszahlungsbetrag (€) *
                </Label>
                <Input
                    type="number"
                    min="0"
                    value={form.pawn_payout_eur}
                    onChange={(e) => update("pawn_payout_eur", e.target.value)}
                    placeholder="z. B. 3.500"
                    className="mt-1.5 rounded-sm bg-white text-[#111827] font-mono-num"
                    data-testid="form-pawn-payout"
                />
            </div>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    Laufzeit (Monate)
                </Label>
                <Input
                    type="number"
                    min="1"
                    max="120"
                    value={form.pawn_term_months}
                    onChange={(e) => update("pawn_term_months", e.target.value)}
                    placeholder="z. B. 6"
                    className="mt-1.5 rounded-sm bg-white text-[#111827] font-mono-num"
                    data-testid="form-pawn-term"
                />
            </div>
            <div>
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    Rückkaufpreis (€)
                </Label>
                <Input
                    type="number"
                    min="0"
                    value={form.pawn_buyback_eur}
                    onChange={(e) => update("pawn_buyback_eur", e.target.value)}
                    placeholder="z. B. 4.200"
                    className="mt-1.5 rounded-sm bg-white text-[#111827] font-mono-num"
                    data-testid="form-pawn-buyback"
                />
            </div>
            <div className="md:col-span-3">
                <Label className="text-xs font-bold uppercase tracking-wider text-white/60">
                    Verwendung der Auszahlung
                </Label>
                <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2" data-testid="pawn-usages">
                    {USAGE_OPTIONS.map((opt) => {
                        const active = usages.includes(opt.key);
                        return (
                            <button
                                key={opt.key}
                                type="button"
                                onClick={() => toggleUsage(opt.key)}
                                className={`text-left text-sm rounded-sm border-2 px-3 py-2.5 transition-colors ${active ? "border-[#FFCC00] bg-[#FFCC00]/15 text-white" : "border-white/20 text-white/70 hover:border-white/40"}`}
                                data-testid={`pawn-usage-${opt.key}`}
                                aria-pressed={active}
                            >
                                <span className={`inline-flex w-4 h-4 mr-2 rounded-sm border align-middle ${active ? "bg-[#FFCC00] border-[#FFCC00]" : "border-white/40"}`} />
                                {opt.label}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className="md:col-span-3 text-[11px] text-white/50 flex items-start gap-2">
                <span className="text-[#FFCC00]">★</span>
                <span>Beim Pfand / Refinanzieren hinterlegen Sie Ihr Fahrzeug gegen eine Auszahlung. Innerhalb der Laufzeit können Sie es zum Rückkaufpreis zurückerwerben.</span>
            </div>
        </div>
    );
}
